module.exports = __webpack_public_path__ + "static/img/icon4.cc9f12ca.png";